import HeroWithLogoAwardsArchive from "./heroWithLogoAwardsArchive";

export default HeroWithLogoAwardsArchive;
